import { roundValue, safeParseFloat } from "lib/number";
import { MergedColumnFormulaOptions } from "./types";
import { PLAN_ROWS as formulaPlanRows } from "../formulas/formula-plan-rows";
import { loopNestedChildren } from "./ag-grid-helper";

/**
 * Loop through row group children and recompute PLAN_ROW value.
 * This is very useful when we can't re-use computed values because PLAN_ROW metrics is not turned on, thus, the column doesn't exist.
 * @param factoryOptions
 * @param getterParams
 * @returns
 */
export const getChildrenPlanRow = (factoryOptions, getterParams) => {
    let sumValue = 0;
    const { node } = getterParams;
    loopNestedChildren(node, (childNode) => {
        const value = formulaPlanRows({
            factoryOptions,
            getterParams: {
                ...getterParams,
                node: childNode,
                data: childNode.data,
            },
        });

        sumValue += +(value ?? 0);
    });

    return sumValue;
};

/**
 * All this function does is summing values from children rows
 */
export const PLAN_ROWS = (values: number[], options: MergedColumnFormulaOptions) => {
    return roundValue(
        values.reduce((acc, value) => acc + safeParseFloat(value, 0), 0),
        options.decimal
    );
};
